import {
  Editor
} from 'slate';

import HelptapEditor from '../../helpers';
import types from '../../elements/types';

function withCarousel(editor) {

  const { normalizeNode } = editor;

  editor.normalizeNode = entry => {

    const [node, path] = entry;

    if (node.type === types.CAROUSEL) {

      const removed = HelptapEditor.carousel.removeEmptyCarousel(editor, path);

      if (removed === true) {
        return;
      }

      const handled = HelptapEditor.carousel.normalizeCarouselChildren(editor, path);

      if (handled === true) {
        return;
      }

    }

    if (node.type === types.CAROUSEL_ITEM) {

      const carouselEntry = Editor.above(editor, {
        at: path,
        match: n => {
          return n.type === types.CAROUSEL;
        }
      });

      if (carouselEntry) {

        const carouselNode = carouselEntry[0];
        const carouselPath = carouselEntry[1];

        const handled = HelptapEditor.carousel.syncItemStyles(editor, carouselNode, carouselPath, node);

        if (handled === true) {
          return;
        }

      }

    }

    normalizeNode(entry);

  };

  return editor;

}

export default withCarousel;
